// extracted by mini-css-extract-plugin
export var root = "_4Sri";
export var rootCacaoBloom = "j4fb";
export var rootFigcaption = "o8vz";
export var rootFigcaptionIcon = "lqAo";
export var rootFigcaptionName = "_8PHZ";
export var rootFigcaptionText = "MfM9";
export var rootFigcaptionWrapper = "plNl";
export var rootFigure = "FJtz";
export var rootGlowStories = "unIg";
export var rootImage = "etEP";
export var rootPicture = "u5CE";
export var rootPictureCaption = "drxf";
export var rootPictureHover = "_31OU";
export var rootPictureImage = "+f0-";
export var rootPictureWrapper = "GgHG";
export var rootProductName = "I2lL";
export var rootQuote = "Cttl";
export var rootRiseAndShine = "MmpU";
export var rootRiseAndShineLight = "qrcM";
export var rootSleepWell = "jc0b";
export var rootSunnyMood = "NOCF";
export var rootVertical = "Z74Z";
export var rootVideo = "UVcL";